module.exports = __webpack_public_path__ + "static/media/vviLogo.8328a74b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vviLogo.png
// module id = 921
// module chunks = 0